import React from "react";
import PropTypes from "prop-types";
import styles from "components/manage-vendors/add-vendor-rules-modal.scss";
import { categoryType } from "custom-prop-types";
import { Modal } from "components/common/modal";
import { Select } from "components/common/select";
import { Button } from "components/common/button";

export const AddVendorRulesModal = ({
  categories,
  isAddVendorRulesLoading,
  isAddVendorRulesMode,
  onAddVendorRules,
  onEndAddVendorRulesMode,
  onSelectCategory,
  selectedCategory,
  selectedVendorIds
}) => (
  <Modal
    isVisible={ isAddVendorRulesMode }
    onClose={ onEndAddVendorRulesMode }
    transitionName={ "add-vendor-rules" }
  >
    <h2>Add vendor rules</h2>
    <div className={ styles["vendor-list"] }>Selected vendors: {mapSelectedVendors(selectedVendorIds)}</div>
    <div className={ styles.actions }>
      <Select
        data={ mapCategories(categories) }
        onChange={ (e) => onSelectCategory(e) }
        placeholder="Select a category..."
        value={ selectedCategory }
      />
      <Button
        disabled={ !selectedCategory }
        loading={ isAddVendorRulesLoading }
        onClick={ () => onAddVendorRules() }
        primary
      >
        Add Rule
          </Button>
      <Button link onClick={ onEndAddVendorRulesMode }>cancel</Button>
    </div>
  </Modal>
);

AddVendorRulesModal.defaultProps = {
  selectedCategory: null,
  selectedVendorIds: []
};

AddVendorRulesModal.propTypes = {
  categories: PropTypes.arrayOf(categoryType).isRequired,
  isAddVendorRulesLoading: PropTypes.bool.isRequired,
  isAddVendorRulesMode: PropTypes.bool.isRequired,
  onAddVendorRules: PropTypes.func.isRequired,
  onEndAddVendorRulesMode: PropTypes.func.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  selectedCategory: categoryType,
  selectedVendorIds: PropTypes.arrayOf(PropTypes.string)
};

const mapCategories = (categories) => categories.map((category) => ({
  key: category.name,
  name: category.name,
  info: category.id
}));

const mapSelectedVendors = (vendors) => (
  vendors.map((vendor, index) => {
    const comma = index === vendors.length - 1 ? "" : ",";
    return (
      <span className={ styles.vendor } key={ vendor }>{vendor}{comma}</span>
    );
  })
);



// WEBPACK FOOTER //
// ./src/js/components/manage-vendors/add-vendor-rules-modal.jsx